import { render, staticRenderFns } from "./ActDetails.vue?vue&type=template&id=68eb794a"
import script from "./ActDetails.vue?vue&type=script&lang=js"
export * from "./ActDetails.vue?vue&type=script&lang=js"
import style0 from "./ActDetails.vue?vue&type=style&index=0&id=68eb794a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports